import comfortPackService from '../../api/comfortpack'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  actions: {
    async getComfortPackList({ dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const response = await comfortPackService.getSensors()
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async createSensor({ dispatch }, sensor) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await comfortPackService.createSensor(sensor)
        dispatch('Global/showMessage', 'createComfortPackSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async editSensor({ dispatch }, sensor) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await comfortPackService.editSensor(sensor)
        dispatch('Global/showMessage', 'editComfortPackSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async deleteSensor({ dispatch }, sensorId) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await comfortPackService.deleteSensor(sensorId)
        dispatch('Global/showMessage', 'deviceDeletedSuccessfully', {root: true})
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    }
  }
}
